// extracted by mini-css-extract-plugin
export var dropdownContainer = "_kd-0";
export var leftAlign = "_kd-4";
export var listItem = "_kd-2";
export var listItemWrapper = "_kd-1";
export var operationText = "_kd-3";